import React from 'react';
import './header.css';

const Header = (props) => (
  <div className="header">
    How many teaspoons?
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/main/header.js